module.exports = __webpack_public_path__ + "static/media/icon_170.ef857fd3.svg";